import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Row, Col, Container, Alert } from 'react-bootstrap';
import { Link, useParams, Navigate } from 'react-router-dom';
import DiarioService from '../../../../../services/diario-auth';



const FormArquivo = () => {
    const [arquivo, setArquivo] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [ano, setAno] = useState("");
    const handleUpload = (e) => setArquivo(e.target.files[0]);

    async function pegaAno(id) {
        const response = await DiarioService.diarioEdit(id);
            setAno(response.data["ano"]);
    }

    useEffect(() => {
        pegaAno(id)
    }, [])

    const { id } = useParams();
    const montaForm = async () => {
        const diario = new FormData();
        diario.append("arquivo", arquivo);
        diario.append("ano", ano);
        return diario
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const diario = await DiarioService.arquivo(id, ano, dados)
            if (diario.data["cod_diario"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col lg={10}>
                                    <Form.Group className="mb-3" controlId="arquivo">
                                        <Form.Label>Arquivo do Diário</Form.Label>
                                        <Form.Control
                                            required
                                            type="file"
                                            name="arquivo"
                                            onChange={handleUpload}
                                            accept="application/pdf"
                                        />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <br />
                        <Link to={'/restrito/diario/listar'}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Diário editado com sucesso!</Alert>
                <Navigate to={'/restrito/diario/listar'} />
            </Fragment>
        )
    }
}

export default FormArquivo